<template>
  <div>
    <h4
      class="mb-4 bold text-overflow"
      v-if="
        ($route.query.type != 'DOC_SIGN_CONSENT' &&
          $route.query.statusFilter !== 'DOC_WAITING') ||
        ($route.query.type == 'FILTER' &&
          $route.query.statusFilter !== 'DOC_WAITING')
      "
    >
      Chuyển văn bản "{{ `${mData.dataForm.name ? mData.dataForm.name : '...' }` }}"
    </h4>
    <h4
      class="mb-4 bold text-overflow"
      v-if="
        $route.query.type == 'DOC_SIGN_CONSENT' ||
        ($route.query.type == 'FILTER' &&
          $route.query.statusFilter == 'DOC_WAITING')
      "
    >
      Yêu cầu ký nháy văn bản "{{ `${mData.dataForm.name ? mData.dataForm.name : '...' }` }}"
    </h4>
    <b-row class="mb-3">
      <b-col md="6" class="left-side p-0">
        <h6 class="bold mb-3" v-if="$route.query.type != 'DOC_SIGN_CONSENT'">
          1. Chọn cá nhân, đơn vị hoặc nhóm bên dưới để chuyển văn bản
        </h6>
        <h6 class="bold mb-3" v-if="$route.query.type == 'DOC_SIGN_CONSENT'">
          1. Chọn cá nhân, đơn vị hoặc nhóm bên dưới để ký nháy
        </h6>
        <div class="w-100 mr-3 mb-3">
          <el-input
            type="text"
            v-model="textFilter"
            placeholder="Tìm kiếm người dùng, đơn vị, nhóm (Enter để tìm kiếm)"
            prefix-icon="fal fa-search"
            @keyup.enter.native="fn_getListDataByTab(true)"
          ></el-input>
        </div>
        <!-- Start Tab -->
        <el-tabs
          type="border-card"
          v-model="tabName"
          @tab-click="fn_handleClickTab"
        >
          <!-- Start Tab CaNhan -->
          <el-tab-pane name="CaNhan">
            <span slot="label">
              <div class="d-flex justify-content-center align-items-center">
                <i class="icon icon24-Profile mr-2"></i>
                <span>Chọn cá nhân</span>
              </div>
            </span>
            <div
              v-if="listPeopleFilter.length == 0"
              class="text-center center-block"
            >
              <h5 class="empty__tab-text">Không có dữ liệu.</h5>
            </div>
            <!-- Start Tab Body -->
            <el-card
              shadow="hover"
              v-for="(emp, i) in listPeopleFilter"
              :key="i"
              :class="{
                'card-item': true,
                checked: emp.value,
                'pointer-not-allow': emp.not_change,
              }"
            >
              <b-form-checkbox
                :data-id="`${emp.id}-${emp.position_id}`"
                v-model="emp.value"
                @change="fn_toggleTag(emp)"
                :disabled="emp.not_change"
                :class="{
                  'pointer-not-allow': emp.not_change,
                }"
              >
                <el-avatar
                  :src="emp.avt ? emp.avt : 'img/Vector-person.png'"
                  class="ml-2 mr-2"
                ></el-avatar>
                <div>
                  <div class="d-flex align-items-center">
                    <p class="bold mb-1 text-overflow-380">
                      {{ emp.administrative_info.name.full_name }}
                    </p>
                    <div
                      class="ml-2 d-flex align-items-center urgency urgent"
                      v-if="emp.is_transfered"
                    >
                      <i class="icon isax-sms-tracking c-white mr-1"></i>
                      <p class="c-white">Đã nhận</p>
                    </div>
                  </div>
                  <p>
                    <span
                      class="span__block-overflow"
                      :title="emp.employee_no"
                      >{{ emp.employee_no }}</span
                    >
                    •
                    {{
                      emp.administrative_info.phone_number
                        ? emp.administrative_info.phone_number
                        : "**** *** ***"
                    }}
                    {{ emp.position_name ? "• " + emp.position_name : "" }}
                  </p>
                </div>
              </b-form-checkbox>
            </el-card>
            <!-- Start Tab Body -->
          </el-tab-pane>
          <!-- End Tab CaNhan -->

          <!-- Start Tab CaNhan -->
          <el-tab-pane name="DonVi">
            <span slot="label">
              <div class="d-flex justify-content-center align-items-center">
                <i class="icon icon24-Tree mr-2"></i>
                <span>Chọn đơn vị</span>
              </div>
            </span>
            <div
              class="text-center center-block"
              v-if="mData.dataDefault.listOrganizationModelTree.length == 0"
            >
              <h5 class="empty__tab-text">Không có dữ liệu.</h5>
            </div>
            <!-- show-checkbox -->
            <el-tree
              v-else
              :data="mData.dataDefault.listOrganizationModelTree"
              default-expand-all
              ref="organizationModelTree"
              :props="defaultProps"
              :filter-node-method="fn_filterNode"
            >
              <!-- @check="fn_getCheckedNodes" -->
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <div class="d-flex align-items-center">
                  <!-- <p v-if="!node.isLeaf">{{ node.label }}</p> -->
                  <p v-if="!data.type">{{ data.label }}</p>
                  <el-card
                    shadow="hover"
                    :class="{
                      'card-item': true,
                      checked: node.checked,
                      'pointer-not-allow': data.not_change,
                    }"
                  >
                    <!-- v-if="node.isLeaf" -->
                    <b-form-checkbox
                      v-if="data.type == 'employee'"
                      :data-id="`${data.id}-${data.position_id}`"
                      v-model="node.checked"
                      @change="
                        fn_checkManipulately(data, node.checked, false, true)
                      "
                      :disabled="node.not_change"
                      :class="{
                        'pointer-not-allow': node.not_change,
                      }"
                    >
                      <el-avatar
                        :src="data.avt ? data.avt : 'img/Vector-person.png'"
                        class="ml-2 mr-2"
                      ></el-avatar>
                      <div>
                        <div class="d-flex align-items-center">
                          <p class="bold mb-1 text-overflow-380">
                            {{ data.label }}
                          </p>
                          <div
                            class="
                              ml-2
                              d-flex
                              align-items-center
                              urgency
                              urgent
                            "
                            v-if="data.is_transfered"
                          >
                            <i class="icon isax-sms-tracking c-white mr-1"></i>
                            <p class="c-white">Đã nhận</p>
                          </div>
                        </div>
                        <p>
                          <span
                            class="span__block-overflow"
                            :title="data.employee_no"
                            >{{ data.employee_no }}</span
                          >
                          •
                          {{
                            data.phone_number
                              ? data.phone_number
                              : "**** *** ***"
                          }}
                          {{
                            data.position_name ? "• " + data.position_name : ""
                          }}
                        </p>
                      </div>
                    </b-form-checkbox>
                  </el-card>
                </div>
              </span>
            </el-tree>
          </el-tab-pane>
          <!-- End Tab CaNhan -->

          <!-- Start Tab Nhom -->
          <el-tab-pane name="Nhom">
            <span slot="label">
              <div class="d-flex justify-content-center align-items-center">
                <i class="icon icon24-Group mr-2"></i>
                <span>Chọn nhóm</span>
              </div>
            </span>
            <div
              class="text-center center-block"
              v-if="mData.dataDefault.listDocumentBusiness.length == 0"
            >
              <h5 class="empty__tab-text">Không có dữ liệu.</h5>
            </div>
            <el-tree
              v-else
              :data="mData.dataDefault.listDocumentBusiness"
              default-expand-all
              ref="businessTree"
              :props="defaultProps"
              :filter-node-method="fn_filterNode"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <div class="d-flex align-items-center">
                  <p v-if="!data.type">{{ data.label }}</p>
                  <el-card
                    shadow="hover"
                    :class="{
                      'card-item': true,
                      checked: node.checked,
                      'pointer-not-allow': data.not_change,
                    }"
                  >
                    <b-form-checkbox
                      v-if="data.type == 'employee'"
                      :data-id="`${data.id}-${data.position_id}`"
                      v-model="node.checked"
                      @change="
                        fn_checkManipulately(data, node.checked, false, true)
                      "
                      :disabled="node.not_change"
                      :class="{
                        'pointer-not-allow': node.not_change,
                      }"
                    >
                      <el-avatar
                        :src="data.avt ? data.avt : 'img/Vector-person.png'"
                        class="ml-2 mr-2"
                      ></el-avatar>
                      <div>
                        <div class="d-flex align-items-center">
                          <p class="bold mb-1 text-overflow-380">
                            {{ data.label }}
                          </p>
                          <div
                            class="
                              ml-2
                              d-flex
                              align-items-center
                              urgency
                              urgent
                            "
                            v-if="data.is_transfered"
                          >
                            <i class="icon isax-sms-tracking c-white mr-1"></i>
                            <p class="c-white">Đã nhận</p>
                          </div>
                        </div>
                        <p>
                          <span
                            class="span__block-overflow"
                            :title="data.employee_no"
                            >{{ data.employee_no }}</span
                          >
                          {{
                            data.phone_number
                              ? "• " + data.phone_number
                              : "• " + "**** *** ***"
                          }}
                          {{
                            data.position_name ? "• " + data.position_name : ""
                          }}
                        </p>
                      </div>
                    </b-form-checkbox>
                  </el-card>
                </div>
              </span>
            </el-tree>
          </el-tab-pane>
          <!-- End Tab Nhom -->

          <!-- Start Tab GanDay -->
          <el-tab-pane name="GanDay">
            <span slot="label">
              <div class="d-flex justify-content-center align-items-center">
                <i class="icon isax-clock mr-2"></i>
                <span>Chọn gần đây</span>
              </div>
            </span>
            <div
              v-if="listNearestHistory.length == 0"
              class="text-center center-block"
            >
              <h5 class="empty__tab-text">Không có dữ liệu.</h5>
            </div>
            <!-- Start Tab Body -->
            <el-card
              shadow="hover"
              v-for="(emp, i) in listNearestHistory"
              :key="i"
              :class="{
                'card-item': true,
                checked: emp.value,
                'pointer-not-allow': emp.not_change,
              }"
            >
              <b-form-checkbox
                :data-id="`${
                  $route.query.handle == 'transfer'
                    ? emp.receiver_id
                    : emp.signer_id
                }-${emp.position_id}`"
                v-model="emp.value"
                @change="fn_toggleTag(emp)"
                :disabled="emp.not_change"
                :class="{
                  'pointer-not-allow': emp.not_change,
                }"
              >
                <el-avatar
                  :src="emp.avt ? emp.avt : 'img/Vector-person.png'"
                  class="ml-2 mr-2"
                ></el-avatar>
                <div>
                  <div class="d-flex align-items-center">
                    <p class="bold mb-1 text-overflow-380">
                      {{ emp.administrative_info.name.full_name }}
                    </p>
                    <div
                      class="ml-2 d-flex align-items-center urgency urgent"
                      v-if="emp.is_transfered"
                    >
                      <i class="icon isax-sms-tracking c-white mr-1"></i>
                      <p class="c-white">Đã nhận</p>
                    </div>
                  </div>
                  <p>
                    <span
                      class="span__block-overflow"
                      :title="emp.employee_no"
                      >{{ emp.employee_no }}</span
                    >
                    •
                    {{
                      emp.administrative_info.phone_number
                        ? emp.administrative_info.phone_number
                        : "**** *** ***"
                    }}
                    {{ emp.position_name ? "• " + emp.position_name : "" }}
                  </p>
                </div>
              </b-form-checkbox>
            </el-card>
          </el-tab-pane>
          <!-- End Tab GanDay -->
        </el-tabs>
        <!-- End Tab -->
      </b-col>

      <b-col md="6" class="pr-0 right-side">
        <h6 class="bold mb-3" v-if="$route.query.type != 'DOC_SIGN_CONSENT'">
          2. Nhập nội dung chuyển
        </h6>
        <h6 class="bold mb-3" v-if="$route.query.type == 'DOC_SIGN_CONSENT'">
          2. Nhập nội dung
        </h6>
        <el-input
          type="textarea"
          v-model="contentTransfer"
          placeholder="Nhập nội dung"
          clearable
          show-word-limit
          maxlength="2000"
          @input="forceUpdateUI"
          resize="none"
        ></el-input>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col md="8" class="p-0">
        <p class="bold mt-2" v-if="listTag.length == 0">
          <span class="bold" style="font-size: 14px">Đến:</span>
          <span style="color: #7e7e7e">
            "Vui lòng chọn ít nhất 1 người nhận"</span
          >
        </p>
        <b-row v-if="listTag.length > 0">
          <b-col md="1" class="pl-0 pr-1" style="margin-top: 7px">
            <span class="bold">Đến ({{ listTag.length }}):</span>
          </b-col>
          <b-col md="11" class="p-0" v-if="listTag && listTag.length > 0">
            <el-tag
              class="mb-2 mr-2"
              v-for="(tag, i) in listTag"
              :key="i"
              :disable-transitions="false"
              :data-idd="tag.id"
              :title="`${
                tag.name +
                (tag.position_name ? ' (' + tag.position_name + ')' : '')
              }`"
            >
              <div
                class="d-flex justify-content-between align-items-center h-100"
              >
                <el-avatar
                  size="small"
                  :src="tag.avt ? tag.avt : 'img/Vector-person.png'"
                  class="ml-2 mr-2"
                ></el-avatar>
                <div class="d-flex align-items-center">
                  <p class="tag__name-overflow mr-1">{{ tag.name }}</p>
                  <p>{{ tag.position_name ? `(${tag.position_name})` : "" }}</p>
                </div>
                <i
                  v-if="$route.query.handle == 'transfer' || !tag.not_change"
                  class="el-tag__close el-icon-close"
                  @click="fn_closeTag(tag)"
                ></i>
              </div>
            </el-tag>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="4" class="p-0">
        <div
          v-if="
            $route.query.type == 'DOC_SIGN_CONSENT' ||
            ($route.query.type == 'FILTER' &&
              $route.query.statusFilter == 'DOC_WAITING')
          "
          class="d-flex justify-content-end align-items-center"
        >
          <h6 class="bold" style="width: 80px">Hạn xử lý</h6>
          <el-date-picker
            class="datePicker"
            type="date"
            v-model="deadline"
            placeholder="Chọn"
            format="dd/MM/yyyy"
            prefix-icon="isax-calendar-1"
            :clearable="false"
            :picker-options="pickerOptionFrom"
          ></el-date-picker>
        </div>
        <!-- Start Manipulate button -->
        <div
          class="text-right pb-3 action__btn"
          :class="$route.query.handle != 'transfer' ? 'mt-3' : 'mt-5'"
        >
          <el-button
            v-if="viewMode == 'create'"
            class="btn__doc btn__doc-back"
            @click="fn_goBack"
            >Quay lại</el-button
          >
          <el-button
            v-if="
              (viewMode == 'create' &&
                $route.query.type != 'DOC_SIGN_CONSENT' &&
                $route.query.statusFilter !== 'DOC_WAITING') ||
              ($route.query.type == 'FILTER' &&
                $route.query.statusFilter !== 'DOC_WAITING')
            "
            :disabled="listTag.length == 0"
            class="btn__doc btn__doc-transfer"
            @click="fn_submitForm('transfer')"
            >Chuyển văn bản</el-button
          >
          <el-button
            v-if="
              (viewMode == 'create' &&
                $route.query.type == 'DOC_SIGN_CONSENT') ||
              ($route.query.type == 'FILTER' &&
                $route.query.statusFilter == 'DOC_WAITING')
            "
            :disabled="listTag.length == 0"
            class="btn__doc btn__doc-transfer"
            @click="fn_submitForm('request-temp')"
            >Yêu cầu ký nháy</el-button
          >
        </div>
        <!-- End Manipulate button -->
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ExtensionService from "../../../service/ExtensionService";
import MethodService from "../../../service/MethodService";
import EmployeeApi from "../../../moduleApi/EmployeeApi";
import DocumentApi from "../../../moduleApi/DocumentApi";
import { dataDocMixins } from "../ElectronicDocument/DocumentMixins/dataDocMixins";
import { fnDocMixins } from "../ElectronicDocument/DocumentMixins/fnDocMixins";
import ElectronicDocument from "../ElectronicDocument/DocumentList.vue";
import { Filter } from "mushroomjs";

export default {
  mixins: [dataDocMixins, fnDocMixins],
  components: {
    ElectronicDocument,
  },
  data() {
    return {
      dialogRecall: false,
      dialogInProcess: false,
      tabName: "",
      textFilter: "",
      listPeopleFilter: [],

      textFindGroup: "",
      listDocumentGroupFilter: [],
      listTag: [],

      defaultProps: {
        children: "children",
        label: "label",
      },
      contentTransfer: "",
      deadline: "",
    };
  },

  watch: {
    textFilter(val) {
      if (this.tabName == "DonVi") this.$refs.organizationModelTree.filter(val);
      if (this.tabName == "Nhom") this.$refs.businessTree.filter(val);
    },
  },

  methods: {
    fn_filterNode(value, data, node) {
      if (!value) return true;
      return (
        data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
        (data.field_filter &&
          (data.field_filter.indexOf(value) !== -1 ||
            data.field_filter.indexOf(value.toLowerCase()) !== -1)) ||
        (data.parents_field &&
          (data.parents_field.indexOf(value) !== -1 ||
            data.parents_field.indexOf(value.toLowerCase()) !== -1)) ||
        (data.employee_no && data.employee_no.indexOf(value) !== -1) ||
        (data.email && data.email.indexOf(value) !== -1)
      );
    },

    fn_checkManipulately(
      data,
      val,
      isFromDetail,
      isAddToListTag,
      isSearch,
      isDuplicate
    ) {
      let elements = [];
      const empTargetId =
        this.$route.query.handle == "transfer" &&
        this.tabName == "GanDay" &&
        data.receiver_id
          ? data.receiver_id
          : this.$route.query.handle !== "transfer" &&
            this.tabName == "GanDay" &&
            data.signer_id
          ? data.signer_id
          : data.id;
      // console.log("VAL>>>", val, data,`${empTargetId}-${data.position_id}`)
      // console.log("VAL>>>", data, val, isFromDetail, isAddToListTag, isSearch, isDuplicate)

      elements = document.querySelectorAll(
        `[data-id="${empTargetId}-${data.position_id}"]`
      );
      elements.forEach((e) => {
        e.checked = val;
        if (val && !isDuplicate) {
          $(e).closest(".el-card.card-item").addClass("checked");
        } else {
          $(e).closest(".el-card.card-item").removeClass("checked");
        }
        if (
          isFromDetail &&
          isAddToListTag &&
          !isSearch &&
          data.not_change &&
          this.$route.query.handle !== "transfer"
        ) {
          $(e).closest(".el-card.card-item").addClass("pointer-not-allow");
          $(e).prop("disabled", true);
        }
      });
      if (!isFromDetail || (isFromDetail && isAddToListTag)) {
        let objEmp = null;
        const employee = this.mData.dataDefault.listEmployee.find(
          (emp) => emp.id == data.id
        );
        if (employee) {
          objEmp = {
            id: data.id,
            value: val ? true : false,
            administrative_info: employee.administrative_info
              ? employee.administrative_info
              : "",
            job_info: employee.job_info ? employee.job_info : "",
            position_id: data.position_id,
            position_name: data.position_name,
            employee_no: employee.employee_no ? employee.employee_no : "---",
            avt: employee.image_id
              ? ExtensionService.urlImg +
                employee.image_id +
                "&r=square&w=512"
              : employee.administrative_info.avatar_id
              ? ExtensionService.urlImg +
                employee.administrative_info.avatar_id +
                "&r=square&w=512"
              : "",
          };
          this.fn_toggleTag(objEmp, true, isAddToListTag);
        }
      }
    },

    async fn_handleClickTab(tab, event) {
      this.tabName = tab.name;
      this.textFilter = "";
      if (this.tabName == "CaNhan")
        this.listPeopleFilter = this.listPeopleFilterRaw;
      else if (this.tabName == "DonVi")
        this.$refs.organizationModelTree.filter("");
      else if (this.tabName == "Nhom") this.$refs.businessTree.filter("");
      else if (
        this.tabName == "GanDay" &&
        this.$route.query.handle !== "transfer"
      ) {
        this.listNearestHistory = this.listTempSignRequestHistory;
        this.listNearestHistory = this.fn_removeMainSignerSigned(
          this.listNearestHistory,
          this.mData.dataForm.signers
        );
      } else if (
        this.tabName == "GanDay" &&
        this.$route.query.handle == "transfer"
      )
        this.listNearestHistory = this.listTransferHistory;
    },

    fn_checkSignerEditable(arrPeople, isNearest, isListTag) {
      if (
        this.mData.dataForm.signers &&
        this.mData.dataForm.signers.length > 0
      ) {
        const currentSigner = this.mData.dataForm.signers.find(
          (signer) =>
            signer.status == "WAITING" ||
            signer.status == "SIGNING" ||
            signer.status == "SIGNED_FAILED"
        );
        if (
          currentSigner &&
          currentSigner.request_temp_signers &&
          currentSigner.request_temp_signers.length > 0
        ) {
          const tempSignerHandled = currentSigner.request_temp_signers.map(
            (signer) => {
              if (signer.status == "SIGNED" || signer.status == "REJECTED") {
                return signer.user_id;
              }
            }
          );
          if (tempSignerHandled) {
            arrPeople.forEach((person) => {
              if (
                this.$route.query.handle !== "transfer" &&
                !isNearest &&
                tempSignerHandled.includes(person.id)
              ) {
                // arrPeople = listPeopleFilter <id>
                person.not_change = true;
              } else if (
                this.$route.query.handle !== "transfer" &&
                isNearest &&
                tempSignerHandled.includes(person.signer_id)
              ) {
                // arrPeople = listNearest <signer_id>
                person.not_change = true;
              } else if (
                this.$route.query.handle !== "transfer" &&
                isListTag &&
                tempSignerHandled.includes(person.id)
              ) {
                // arrPeople = listTag <id>
                person.not_change = true;
              } else {
                person.not_change = false;
              }
            });
          }
        }
        this.forceUpdateUI();
      }
    },

    fn_removeMainSignerSigned(listPeople, listMainSigner) {
      const newArr = listPeople.filter((person) => {
        const o = listMainSigner.find(
          (signer) =>
            signer.status == "SIGNED" &&
            (signer.user_id == person.id || signer.user_id == person.signer_id)
        );
        // listPeopleFilter <id> || listNearest<signer_id>
        if (
          person.id == this.mData.currentUser.id ||
          person.signer_id == this.mData.currentUser.id ||
          o
        )
          return false;
        return true;
      });
      return newArr;
    },

    async fn_getListDataByTab(isSearch) {
      if (this.tabName == "CaNhan") {
        this.fn_getDataTabIndividual(isSearch);
      } else if (this.tabName == "GanDay") {
        this.fn_getDataTabNearest();
      }
    },

    async fn_getDataTabIndividual(isSearch) {
      const filter = Filter.and(
        Filter.eq("status", "DANG_LAM_VIEC"),
        Filter.ne("disabled", true),
        Filter.or(
          Filter.regex("employee_no", this.textFilter), // x:regex_i:ab[cd]
          Filter.regex("administrative_info.email", this.textFilter),
          Filter.regex(
            "administrative_info.name.full_name",
            this.textFilter,
            "i"
          )
        )
      ).build();
      const employeeApiRes = await EmployeeApi.list({
        limit: 5000,
        fields: "administrative_info,employee_no,job_info,image_id",
        filters: this.textFilter
          ? filter
          : "status=DANG_LAM_VIEC&disabled!=true",
      });
      if (employeeApiRes.result && employeeApiRes.result.length > 0) {
        this.listPeopleFilter = await this.fn_changeData(employeeApiRes.result);
        // Check result API data to fill data to UI
        if (this.$route.query.handle == "transfer") {
          if (!isSearch) {
            await this.fn_checkSignerFromDetail(
              this.mData.dataForm.transfer &&
                this.mData.dataForm.transfer.person_ids
                ? this.mData.dataForm.transfer.person_ids
                : []
            );
          }
        } else if (
          this.$route.query.handle == "request-sign-temp" &&
          this.mData.dataForm.signers &&
          this.mData.dataForm.signers.length > 0
        ) {
          const target = this.mData.dataForm.signers.find(
            (signer) => signer.user_id == this.mData.currentUser.id
          );
          if (target) {
            if (!isSearch) {
              await this.fn_checkSignerFromDetail(
                target.request_temp_signers &&
                  target.request_temp_signers.length > 0
                  ? target.request_temp_signers
                  : [],
                isSearch
              );
            }
            this.listPeopleFilter = await this.fn_removeMainSignerSigned(
              this.listPeopleFilter,
              this.mData.dataForm.signers
            );
            await this.fn_checkSignerEditable(this.listPeopleFilter);
          }
        }
        if (!isSearch) this.listPeopleFilterRaw = this.listPeopleFilter;
        await this.fn_checkSignerFromDetail(
          this.listTag ? this.listTag : [],
          isSearch
        );
        await this.fn_checkSignerEditable(this.listTag, false, true);
      } else {
        this.listPeopleFilter = [];
      }
    },

    async fn_getDataTabNearest() {
      if (this.$route.query.handle == "transfer") {
        this.listNearestHistory = this.listTransferHistory.filter(
          (person) =>
            (person.name_filter &&
              person.name_filter.includes(this.textFilter.toLowerCase())) ||
            (person.employee_no &&
              person.employee_no.includes(this.textFilter)) ||
            (person.administrative_info &&
              person.administrative_info.name.full_name.includes(
                this.textFilter
              )) ||
            (person.administrative_info &&
              person.administrative_info.email.includes(this.textFilter))
        );
      } else if (this.$route.query.handle !== "transfer") {
        this.listNearestHistory = this.listTempSignRequestHistory.filter(
          (person) =>
            (person.name_filter &&
              person.name_filter.includes(this.textFilter.toLowerCase())) ||
            (person.employee_no &&
              person.employee_no.includes(this.textFilter)) ||
            (person.administrative_info &&
              person.administrative_info.name.full_name.includes(
                this.textFilter
              )) ||
            (person.administrative_info &&
              person.administrative_info.email.includes(this.textFilter))
        );
        this.listNearestHistory = await this.fn_removeMainSignerSigned(
          this.listNearestHistory,
          this.mData.dataForm.signers
        );
      }
    },

    fn_changeData(data) {
      let listResult = [];
      data.forEach((e) => {
        const emp = this.mData.dataDefault.listEmployee.find(
          (emp) => emp.id == e.id
        );
        e.employee_no = emp ? emp.employee_no : "---";
        e.value = e.value == true ? e.value : false;
        e.avt = e.image_id
          ? ExtensionService.urlImg +
            e.image_id +
            "&r=square&w=512"
          : e.administrative_info.avatar_id
          ? ExtensionService.urlImg +
            e.administrative_info.avatar_id +
            "&r=square&w=512"
          : "";
        if (e.job_info && e.job_info.length > 0) {
          e.job_info = MethodService.getValidJobInfo(e.job_info, this.mData.dataDefault.listContractTypeId);
          e.job_info.forEach((job) => {
            let e1 = { ...e };
            const pos = this.mData.dataDefault.listPosition.find(
              (position) => position.id == job.position_id
            );
            e1.position_id = job.position_id;
            e1.position_name = pos ? pos.name : "";
            if (e1.position_id) listResult.push(e1);
          });
        } else {
          listResult.push(e);
        }
      });
      return listResult;
    },

    fn_checkSignerFromTag() {
      if (this.listTag.length > 0) {
        this.listPeopleFilter.forEach((person) => {
          this.listTag.forEach((tag) => {
            if (person.id == tag.id && person.position_id == tag.id) {
              person.value = true;
            }
          });
        });
      }
    },

    fn_checkSignerFromDetail(listSigner, isSearch) {
      if (listSigner.length > 0) {
        // Data tab CaNhan
        this.listPeopleFilter.forEach((person) => {
          listSigner.forEach((signer) => {
            // list this.mData.dataForm.transfer.person_ids || this.listTag || this.mData.dataForm.signers.request_temp_signers
            if (
              this.$route.query.handle !== "transfer" &&
              ((person.id == signer.id &&
                person.position_id == signer.position_id) ||
                (person.id == signer.user_id &&
                  person.position_id == signer.position_id))
            ) {
              // console.log(person.id, signer.id, person.position_id, signer.position_id)
              // listNearestHistory<person.sign_id> - listSigner(listTag <signer.id>) || listSigner(signers.request_temp_signers <signer.user_id>)
              person.value = true;
              person.is_requestTempSigned = true;
              person.status_temp_sign = signer.status
                ? signer.status
                : undefined;
              this.fn_checkManipulately(
                person,
                person.value,
                true,
                true,
                isSearch
              );
            } else if (
              this.$route.query.handle == "transfer" &&
              (person.id == signer.id || person.id == signer)
            ) {
              // listNearestHistory<person.receiver_id> - listSigner(listTag <signer.id>) || listSigner(transfer.person_ids <signer>)
              // person.value = true;
              person.is_transfered =
                person.is_transfered || person.id == signer ? true : false;
            }
          });
        });
        // Data tab GanDay
        this.listNearestHistory.forEach((person) => {
          listSigner.forEach((signer) => {
            if (
              this.$route.query.handle !== "transfer" &&
              ((person.signer_id == signer.id &&
                person.position_id == signer.position_id) ||
                (person.signer_id == signer.id &&
                  person.position_id == signer.position_id))
            ) {
              // listNearestHistory<person.sign_id> - listSigner(listTag <signer.id>) || listSigner(signers.request_temp_signers <signer.user_id>)
              person.value = true;
              person.is_requestTempSigned = true;
            } else if (
              this.$route.query.handle == "transfer" &&
              (person.receiver_id == signer.id || person.receiver_id == signer)
            ) {
              // listNearestHistory<person.receiver_id> - listSigner(listTag <signer.id>) || listSigner(transfer.person_ids <signer>)
              // person.value = true;
              person.is_transfered =
                person.is_transfered || person.receiver_id == signer
                  ? true
                  : false;
            }
          });
        });
      }
    },

    fn_closeTag(tag) {
      // Toggle card at tab CaNhan
      this.listPeopleFilter.forEach((person) => {
        if (person.id == tag.id && person.position_id == tag.position_id) {
          person.value = false;
          return;
        }
      });
      this.fn_checkManipulately(tag, false, true);
      // Toggle card at tab GanDay
      if (this.$route.query.handle == "transfer") {
        this.listNearestHistory.forEach((person) => {
          if (
            person.receiver_id == tag.id &&
            person.position_id == tag.position_id
          ) {
            person.value = false;
            return;
          }
        });
      } else if (this.$route.query.handle !== "transfer") {
        this.listNearestHistory.forEach((person) => {
          if (
            person.signer_id == tag.id &&
            person.position_id == tag.position_id
          ) {
            person.value = false;
            return;
          }
        });
      }

      this.listTag.splice(this.listTag.indexOf(tag), 1);
    },

    fn_toggleCard(emp) {
      if (this.tabName == "CaNhan") {
        const indexEmployee1 = this.listPeopleFilter.findIndex(
          (e) => e.id == emp.id && e.position_id == emp.position_id
        );
        if (indexEmployee1 >= 0)
          this.listPeopleFilter[indexEmployee1].value = false;

        const indexEmployee2 = this.listNearestHistory.findIndex(
          (e) => e.signer_id == emp.id && e.position_id == emp.position_id
        );
        if (indexEmployee2 >= 0)
          this.listNearestHistory[indexEmployee2].value = false;
      } else if (this.tabName == "GanDay") {
        const indexEmployee1 =
          this.listPeopleFilter.findIndex((e) => e.id == emp.signer_id) &&
          e.position_id == emp.position_id;
        if (indexEmployee1 >= 0)
          this.listPeopleFilter[indexEmployee1].value = false;

        const indexEmployee2 = this.listNearestHistory.findIndex(
          (e) =>
            e.signer_id == emp.signer_id && e.position_id == emp.position_id
        );
        if (indexEmployee2 >= 0)
          this.listNearestHistory[indexEmployee2].value = false;
      }
    },

    fn_checkDuplicatePerson(emp) {
      let isDuplicate = null;
      if (
        this.tabName == "CaNhan" ||
        this.tabName == "DonVi" ||
        this.tabName == "Nhom"
      ) {
        isDuplicate = this.listTag.find((e) => e.id == emp.id);
      } else if (
        this.tabName == "GanDay" &&
        this.$route.query.handle == "transfer"
      ) {
        isDuplicate = this.listTag.find((e) => e.id == emp.receiver_id);
      } else if (
        this.tabName == "GanDay" &&
        this.$route.query.handle !== "transfer"
      ) {
        isDuplicate = this.listTag.find((e) => e.id == emp.signer_id);
      }
      return isDuplicate;
    },

    fn_toggleTag(emp, isFromDetail, isAddToListTag) {
      const isDuplicate = this.fn_checkDuplicatePerson(emp);

      if (emp.value && !isDuplicate) {
        const pos = this.mData.dataDefault.listPosition.find(
          (position) => position.id == emp.position_id
        );
        this.listTag.push({
          id:
            this.tabName == "CaNhan" ||
            this.tabName == "DonVi" ||
            this.tabName == "Nhom"
              ? emp.id
              : this.tabName == "GanDay" &&
                this.$route.query.handle == "transfer"
              ? emp.receiver_id
              : emp.signer_id,
          name: emp.administrative_info.name.full_name,
          avt: emp.avt,
          job_info: emp.job_info,
          position_id: emp.position_id,
          position_name: emp.position_name
            ? emp.position_name
            : pos && pos.name
            ? pos.name
            : "",
          status_temp_sign: emp.status_temp_sign
            ? emp.status_temp_sign
            : undefined,
        });
      } else if (!emp.value && isDuplicate) {
        // Toggle at listTag
        this.fn_toggleTagManipulately(emp);
      }
      // Toggle at Tab manipulate
      this.fn_toggleCardForManipulatelyTab(emp);
      // console.log("isFromDetail > isAddToListTag > this.tabName", isFromDetail, isAddToListTag, this.tabName)
      if (
        (isDuplicate &&
          emp.value &&
          isFromDetail &&
          isAddToListTag &&
          (this.tabName == "DonVi" || this.tabName == "Nhom")) ||
        (isDuplicate && emp.value && !isFromDetail)
      ) {
        this.$notify.info({
          message: `Nhân viên này đã tồn tại trong danh sách.`,
          duration: 3000,
          customClass: "doc-info",
        });
        this.fn_checkManipulately(emp, false, true, _, _, true);
      }
    },

    fn_toggleTagManipulately(emp) {
      if (
        this.tabName == "CaNhan" ||
        this.tabName == "DonVi" ||
        this.tabName == "Nhom"
      ) {
        this.listTag = this.listTag.filter(
          (tag) =>
            (tag.id != emp.id && tag.position_id != emp.position_id) ||
            (tag.id == emp.id && tag.position_id != emp.position_id) ||
            (tag.id != emp.id && tag.position_id == emp.position_id)
        );
      } else if (
        this.tabName == "GanDay" &&
        this.$route.query.handle == "transfer"
      ) {
        this.listTag = this.listTag.filter(
          (tag) =>
            (tag.id != emp.receiver_id &&
              tag.position_id != emp.position_id) ||
            (tag.id == emp.receiver_id &&
              tag.position_id != emp.position_id) ||
            (tag.id != emp.receiver_id && tag.position_id == emp.position_id)
        );
      } else if (
        this.tabName == "GanDay" &&
        this.$route.query.handle !== "transfer"
      ) {
        this.listTag = this.listTag.filter(
          (tag) =>
            (tag.id != emp.signer_id && tag.position_id != emp.position_id) ||
            (tag.id == emp.signer_id && tag.position_id != emp.position_id) ||
            (tag.id != emp.signer_id && tag.position_id == emp.position_id)
        );
      }
    },

    fn_toggleCardForManipulatelyTab(emp) {
      if (this.$route.query.handle == "transfer") {
        if (this.tabName == "CaNhan") {
          // Tab DonVi
          this.fn_checkManipulately(emp, emp.value, true);
          // Tab GanDay
          this.listNearestHistory.forEach((person) => {
            if (
              person.receiver_id == emp &&
              person.position_id == emp.position_id
            ) {
              person.value = !person.value;
              return;
            }
          });
        } else if (this.tabName == "GanDay") {
          // Tab DonVi
          this.fn_checkManipulately(emp, emp.value, true);
          // Tab CaNhan
          this.listPeopleFilter.forEach((person) => {
            if (person.id == emp && person.position_id == emp.position_id) {
              person.value = !person.value;
              return;
            }
          });
        } else if (this.tabName == "DonVi" || this.tabName == "Nhom") {
          // Tab CaNhan
          this.listPeopleFilter.forEach((person) => {
            if (person.id == emp.id && person.position_id == emp.position_id) {
              person.value = !person.value;
              return;
            }
          });
          // Tab GanDay
          this.listNearestHistory.forEach((person) => {
            if (
              person.receiver_id == emp.id &&
              person.position_id == emp.position_id
            ) {
              person.value = !person.value;
              return;
            }
          });
        }
      } else if (this.$route.query.handle !== "transfer") {
        if (this.tabName == "CaNhan") {
          this.fn_checkManipulately(emp, emp.value, true);
        } else if (this.tabName == "GanDay") {
          this.fn_checkManipulately(emp, emp.value, true);
        }
      }
    },

    async fn_getDocById() {
      const documentInApiRes = await DocumentApi.findById(
        this.$route.params.id
      );
      if (documentInApiRes.result) {
        this.mData.dataForm = documentInApiRes.result;
        this.fn_eventBus(
          this.checkTab(this.$route.query.type),
          this.$route.query.handle == "transfer"
            ? "transfer"
            : "request-sign-temp",
          this.mData.dataForm.name
        );
        if (this.$route.query.type == "DOC_SIGN_CONSENT") {
          const o = this.mData.dataForm.signers.find(
            (signer) => signer.status == "WAITING"
          );
          if (
            o &&
            o.request_temp_signers &&
            o.request_temp_signers.length > 0
          ) {
            this.deadline = o.request_temp_signers[0].deadline;
          } else {
            this.deadline = this.mData.dataForm.deadline;
          }
        }
      }
    },

    fn_mapDataTransferId() {
      if (
        !this.mData.dataForm.transfer ||
        (this.mData.dataForm.transfer &&
          !this.mData.dataForm.transfer.person_ids)
      ) {
        return this.listTag.map((tag) => tag.id);
      }
      this.listTag.forEach((tag) => {
        if (!this.mData.dataForm.transfer.person_ids.includes(tag.id))
          this.mData.dataForm.transfer.person_ids.push(tag.id);
      });
      return this.mData.dataForm.transfer.person_ids;
    },

    async fn_submitForm(type) {
      try {
        let data = this.mData.dataForm;
        if (type == "transfer") {
          const dataTransfer = {
            id: data.id,
            content: this.contentTransfer,
            transfer_ids: this.listTag.map((tag) => tag.id),
            // transfer_ids: this.fn_mapDataTransferId(),
          };
          const documentInApiRes = await DocumentApi.TransferDocument(
            dataTransfer
          );
          if (documentInApiRes.result) {
            this.$notify.success({
              message: "Chuyển văn bản thành công.",
              duration: 3000,
              customClass: "doc-success",
            });
          }
        } else if (type == "request-temp") {
          let arrTempSigner = [];
          data.signers = data.signers.map((signer) => {
            if (
              signer.user_id == this.mData.currentUser.id &&
              signer.request_temp_signers &&
              signer.request_temp_signers.length > 0
            ) {
              signer.request_temp_signers = this.listTag.map((person, i) => ({
                user_id: person.id,
                position_id: person.position_id ? person.position_id : null,
                content: this.contentTransfer,
                deadline: this.deadline
                  ? new Date(new Date(this.deadline).setHours(23, 59, 59))
                  : null,
                status: signer &&
                  signer.request_temp_signers &&
                  signer.request_temp_signers[i] &&
                  signer.request_temp_signers[i].status
                    ? signer.request_temp_signers[i].status
                    : "NEW",
              }));
              arrTempSigner = signer.request_temp_signers;
            } else if (
              signer.user_id == this.mData.currentUser.id &&
              (!signer.request_temp_signers || signer.request_temp_signers.length === 0)
            ) {
              signer.request_temp_signers = this.listTag.map((person) => ({
                user_id: person.id,
                position_id: person.position_id ? person.position_id : null,
                content: this.contentTransfer,
                deadline: this.deadline
                  ? new Date(new Date(this.deadline).setHours(23, 59, 59))
                  : null,
                status: "NEW",
              }));
              arrTempSigner = signer.request_temp_signers;
            }
            return signer;
          });
          arrTempSigner = arrTempSigner.map((signer) => ({
            user_id: signer.user_id,
            position_id: signer.position_id,
            status: signer.status,
            content: this.contentTransfer,
            deadline: this.deadline
              ? new Date(new Date(this.deadline).setHours(23, 59, 59))
              : null,
          }));

          const dataSignTemp = {
            id: data.id,
            signer_id: this.mData.currentUser.id,
            request_temp_signers: arrTempSigner,
          };
          const res = await DocumentApi.RequestTempSignDocument(dataSignTemp);
          if (res.result) {
            this.$notify.success({
              message: "Yêu cầu ký nháy thành công.",
              duration: 3000,
              customClass: "doc-success",
            });
          }
        }
        await this.fn_goBack();
      } catch (error) {
        // console.log(error);
        if (this.$route.query.handle === "transfer") {
          this.$notify.warning({
            message: `Chuyển văn bản thất bại.`,
            duration: 3000,
            customClass: "doc-warning",
          });
          return;
        }
        this.$notify.warning({
          message: `Yêu cầu ký nháy thất bại.`,
          duration: 3000,
          customClass: "doc-warning",
        });
      }
    },

    async fn_initData() {
      await Promise.all([
        this.fn_getListConTractType(),
        this.fn_getListPosition(),
        this.fn_getListDepartment(),
        this.fn_getListBranch(),
        this.fn_getListEmployee(),
      ])
      if (this.$route.query.handle == "transfer") {
        await this.fn_getTransferHistory();
        this.listNearestHistory = this.listTransferHistory;
      } else {
        await this.fn_getTempSignRequestHistory();
        this.listNearestHistory = this.listTempSignRequestHistory;
      }

      await this.fn_getDocById();
      await this.fn_getListOrganizationModelTree();
      await this.fn_getListDocumentGroupTree();
      await this.fn_getListDataByTab();
      if (this.$route.query.handle !== "transfer") {
        this.listNearestHistory = await this.fn_removeMainSignerSigned(
          this.listNearestHistory,
          this.mData.dataForm.signers
        );
        await this.fn_checkSignerEditable(this.listNearestHistory, true);
      }
    },
  },

  created() {
    this.fn_eventBus(
      this.checkTab(this.$route.query.type),
      this.$route.query.handle == "transfer" ? "transfer" : "request-sign-temp"
    );
    this.tabName = "CaNhan";
    this.mData.dataForm.transfer = {
      content: "",
    };
    this.fn_initData();
  },
};
</script>

<style lang="scss" scoped>
.urgency {
  padding: 3px 6px;
  border-radius: 4px;
  color: white;
  text-align: center;
  &.high-urgency {
    background-color: #f12727;
  }
  &.urgent {
    background-color: #ff5621;
  }
  &.express {
    background: transparent;
    border: 1px solid #ff5621;
    color: #ff5621;
  }
}
::v-deep .empty__tab-text {
  color: #b3b3b3;
}
.checked {
  background: #d0e8f5 !important;
}
::v-deep .el-input__inner {
  border-radius: 0;
  box-shadow: none !important;
  border-radius: 5px !important;
}
::v-deep .el-checkbox {
  .el-checkbox__input.is-checked {
    .el-checkbox__inner {
      background-color: var(--turquoise);
      border-color: var(--turquoise);
    }
  }
  .el-checkbox__input.is-focus {
    .el-checkbox__inner {
      border-color: var(--turquoise) !important;
    }
  }
  .el-checkbox__input.is-indeterminate {
    .el-checkbox__inner {
      background-color: var(--turquoise);
      border-color: var(--turquoise);
    }
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border-color: var(--turquoise);
    top: 3px;
    &:hover {
      border-color: var(--turquoise) !important;
    }
    &:focus {
      border-color: var(--turquoise) !important;
    }
    &:active {
      border-color: var(--turquoise) !important;
    }
  }
}
::v-deep .el-textarea__inner {
  border-radius: 0;
  box-shadow: none !important;
  border-radius: 5px !important;
  height: calc(100vh - 300px);
}
::v-deep .el-input__prefix {
  .el-input__icon.fa-search {
    margin-left: 7px;
  }
}
::v-deep .el-tabs__content {
  overflow: auto;
  .el-tab-pane {
    height: calc(100vh - 430px);

    // overflow-y: scroll;
    .center-block {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
::v-deep .el-tabs__item {
  border-radius: 0;
  background-color: #e9e9e9;

  span {
    color: black;
  }
}
::v-deep .el-tabs__nav {
  &:not(.is-active)::after {
    content: "";
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 2px;
    background: #d0d5d9;
  }
}
::v-deep .el-tabs--border-card > .el-tabs__header {
  .el-tabs__item {
    font-size: 13px;
    border-top: 2px solid transparent;
    margin: 0;
    position: relative;

    &:not(:last-child)::before {
      content: "";
      position: absolute;
      top: 5px;
      right: -1px;
      width: 1px;
      height: 75%;
      background: #7e7e7e;
    }
  }
  .el-tabs__item.is-active {
    border-top: 2px solid var(--orange) !important;
    border-left: none;
    span {
      color: black;
      font-weight: bold;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: -1px;
      right: 0px;
      width: 100%;
      height: 2px;
      background: #fff;
      z-index: 1000;
    }
  }
}
::v-deep .icon {
  cursor: pointer;
  font-size: 21px;
}
::v-deep .isax-trash {
  color: var(--red);
}
::v-deep .isax-eye {
  color: var(--orange);
}
::v-deep .el-upload-dragger {
  height: 36px;
}
::v-deep .el-upload {
  position: relative;
}
::v-deep .el-upload__tip {
  position: absolute;
  top: 5px;
  left: 150px;
  font-style: italic;
  color: #606266;
  margin-top: 0;
}
::v-deep .el-dialog__body {
  padding: 0px !important;
}
::v-deep .el-dialog__header {
  background-color: #fff !important;
  border-bottom: 1px solid #fff !important;
}
::v-deep .datePicker .el-input__prefix,
.el-input__suffix {
  right: 5px;
  left: auto;
}
::v-deep .el-input--suffix .el-input__inner {
  padding-left: 15px;
  padding-right: 15px;
}
::v-deep .el-tag {
  border: none;
  border-radius: 8px;
  background-color: #d0e8f5;
  .el-avatar--small {
    width: 23px;
    height: 23px;
    line-height: 28px;
  }
  .el-icon-close {
    color: var(--black);
    top: 0;
    &:hover {
      color: var(--white);
    }
  }
}
::v-deep .el-tag--small {
  height: 36px;
}
::v-deep .el-date-editor.el-input {
  width: 220px;
}

::v-deep svg path,
svg rect {
  fill: #ccc !important;
}
::v-deep .vue-treeselect__control {
  position: fixed;
  top: 170px;
  left: 140px;
  width: 40%;
  border: none;
  .vue-treeselect__placeholder {
    font-family: "LexendDeca Regular", sans-serif;
    font-size: 14px;
    font-weight: 500;
    padding: 1px 0px 1px 6px;
  }
  .vue-treeselect__multi-value-item {
    display: none;
  }
}
::v-deep .vue-treeselect__menu-container {
  .vue-treeselect__menu {
    border: none;
    height: auto;
    box-shadow: none;
    max-height: none !important;
  }
}
::v-deep .el-textarea {
  .el-input__count {
    bottom: 0px;
  }
}
@media (min-width: 1366px) {
  ::v-deep .el-tabs__nav {
    width: 100%;
    .el-tabs__item {
      width: 25%;
    }
  }
}
@media (max-width: 1180px){
  ::v-deep .btn__doc {
    width: 150px;
  }
}
@media (max-width: 1024px) {
  ::v-deep .action__btn {
    margin-top: 0 !important;
    .btn__doc-back {
      margin-bottom: 10px;
    }
  }
}
/*Ipad dọc(768 x 1024)*/
@media (max-width: 768px){
  ::v-deep .right-side {
    h6 {
      margin-bottom: 30px !important;
    }
  }
}
</style>
